const GaleryManagement = () => {
    return (
        <>
            <h1>GaleryManagement</h1>
        </>
    );
};

export default GaleryManagement;